export interface VolumeRow {
  form_id: string;
  total: number;
  spam: number;
}

/**
 * Whether a form's messages were scored: its spam filter is on, or it flagged
 * something in the period (the filter was on then). Unknown forms count as scored.
 */
export function isScored(spam: number, filterSpam: boolean | undefined): boolean {
  return spam > 0 || (filterSpam ?? true);
}

/** Spam among scored messages only: forms with the filter off never flag anything. */
export function spamShare(
  rows: VolumeRow[],
  scored: (formId: string) => boolean
): { spam: number; scoredTotal: number; share: number | null } {
  let spam = 0;
  let scoredTotal = 0;
  for (const r of rows) {
    if (!scored(r.form_id)) continue;
    spam += r.spam;
    scoredTotal += r.total;
  }
  return { spam, scoredTotal, share: scoredTotal > 0 ? spam / scoredTotal : null };
}
